export default __webpack_public_path__ + "static/media/theme.617f4b8a.mp3";